import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
//import * as moment from 'moment'
import Spinner from "react-bootstrap/Spinner";

import SpecieInfo from "./SpecieInfo"
import SpecieMapModal from "./SpecieMapModal"
import PDFGenerator from "../PDF/PDFGenerator"

// Imágenes
import iconoDescarga from '../../images/iconoDescarga.png'
import iconoLocalizacion from '../../images/iconoLocalizacion.png'
import iconoMapa from '../../images/iconoMapa.png'

class Results extends Component {

    state = {
        selectedSpecie: null,
        selectedPDFSpecie: null,
        selectedSpecieVisor: null
    }


    openSpecieVisor = (e, id) => {
        e.preventDefault();
        this.setState({
            selectedSpecieVisor: id
        })
    }

    downloadPDF = (e, id) => {
        e.preventDefault();
        this.setState({
            selectedPDFSpecie: id
        })
    }

    cleanPDF = () => {
        this.setState({
            selectedPDFSpecie: null
        })
    }

    showSpecieInfo = (e, id) => {
        e.preventDefault();
        this.setState({
            selectedSpecie: id
        })
    }

    closeSpecieInfo = () => {
        this.setState({
            selectedSpecie: null,
            selectedPDFSpecie: null,
            selectedSpecieVisor: null
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if(!prevProps.loading && this.props.loading) {
            this.setState({
                selectedSpecie: null,
                selectedPDFSpecie: null,
                selectedSpecieVisor: null
            })
        }
    }


    renderCards = () => {
        return (
            <div className="resultados">
                {this.props.results.map(sp => {
                    // var sibicDate = new Date(sp.sibic_last_record)
                    // var easinDate = new Date(sp.easin_last_record)
                    // var maxDate
                    //
                    // if (sibicDate.getTime() > easinDate) {
                    //     maxDate = moment(sibicDate).format('DD-MM-YYYY')
                    // } else {
                    //     maxDate = moment(easinDate).format('YYYY')
                    // }

                    return (
                        <div key={sp.species_id} className="card">
                            <div className="row ">
                                <div className="card-image col-md-4 col-sm-12">
                                    {sp.file_name ? (
                                        <img alt="" src={"https://admin.eei.sibic.org/assets/img/species/" + sp.file_name}
                                            className="fit-image" />
                                    ) : ("")}
                                </div>
                                <div className="card-block col-12 col-md-8 row pr-0">
                                    <div className=" card-info col-10 ">
                                        <h4 className="card-title" onClick={e => { this.showSpecieInfo(e, sp.species_id) }}>
                                            <span className="nomb_card"><em>{sp.taxa}</em></span></h4>
                                        {/* <p className="card-text">Último avistamiento: {maxDate}</p> */}
                                    </div>
                                    <div className="card-links col-2 pr-0">
                                        <div style={{cursor: 'pointer'}} title="Descarga de ficha" onClick={e => this.downloadPDF(e, sp.species_id)}>
                                            <img
                                                alt=""
                                                src={iconoDescarga}
                                                className=""
                                                title="Descargar" />
                                        </div>
                                        <div style={{cursor: 'pointer'}} title="Localización en el visor" onClick={(e) => this.openSpecieVisor(e, sp.species_id)}>
                                            <img
                                                alt=""
                                                src={iconoLocalizacion}
                                                className=""
                                                title="Localización en el visor" />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    getEasinIdFromSibicId = () => {
        let relation = this.props.relations.filter(r => r.sibic_id === this.state.selectedSpecie)
        return relation.length > 0 ? relation[0].easin_id : undefined
    }

    getEasinIdFromSibicIdPDF = () => {
        let relation = this.props.relations.filter(r => r.sibic_id === this.state.selectedPDFSpecie)
        return relation.length > 0 ? relation[0].easin_id : undefined
    }

    getEasinIdFromSibicIdModal = () => {
        let relation = this.props.relations.filter(r => r.sibic_id === this.state.selectedSpecieVisor)
        return relation.length > 0 ? relation[0].easin_id : undefined
    }

    render() {

        if (this.props.loading) {
            return <div className="col-md-8" id="datos-especie"><ResultSpinner/></div>
        }

        const { t } = this.props

        return (

            <>
                {this.state.selectedSpecie ?
                    <div className="col-md-8" id="datos-especie">
                        <SpecieInfo sibicId={this.state.selectedSpecie} easinId={this.getEasinIdFromSibicId()} onBack={this.closeSpecieInfo} invasaquaLists={this.props.invasaquaLists} eicatCategories={this.props.eicatCategories}/>
                    </div>
                    :
                    <div className="col-md-8" id="results">
                        <div className="col-xl-10 offset-xl-1">
                            {
                                this.props.results.length ?
                                <h2>{t("titFichas")} ({this.props.results.length})</h2>
                                :
                                <h2>{t("titFichas")} </h2>
                            }
                            {
                                !this.props.results.length ? <p><i>Sin resultados</i></p> : null
                            }

                            {this.renderCards()}
                        </div>
                    </div>
                }
                {
                    this.state.selectedPDFSpecie ?
                        <PDFGenerator
                            id_specie={this.state.selectedPDFSpecie}
                            easinId={this.getEasinIdFromSibicIdPDF()}
                            onFinish={this.cleanPDF}
                            lang={this.props.i18n.language}
                            translateFn={this.props.t}
                            invasaquaLists={this.props.invasaquaLists} 
                            eicatCategories={this.props.eicatCategories}/>
                    : null
                }
                {
                    this.state.selectedPDFSpecie || this.state.selectedSpecie || this.state.selectedSpecieVisor ?
                    null :
                    <a className="btn btn-direct" href="/visor" title="Acceso al visor">
                        <img src={iconoMapa} alt="icono buscador" />{t("mapa-upper")}
                    </a>
                }
                {
                    this.state.selectedSpecieVisor ?
                    <SpecieMapModal sibicId={this.state.selectedSpecieVisor} easinId={this.getEasinIdFromSibicIdModal()} onClose={this.closeSpecieInfo}/>
                    : null
                }
            </>

        );
    }
}

// export default Species;
export default withTranslation()(Results);

const ResultSpinner = props => (
    <div
        className="my_spinner"
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: 400,
            backgroundColor: '#fff'
        }}
    >
        <div>
            <Spinner className="spin m-3" animation="grow" variant="success" />
            <Spinner className="spin m-3" animation="grow" variant="info" />
            <Spinner className="spin m-3" animation="grow" variant="success" />
        </div>
    </div>
)
